module.exports = __webpack_public_path__ + "media/images/brand/meta_icons/apple-touch-icon-152x152-15281dd6473d2972c7e9674471755d8e.png";